<template>
    <VueTagsInput
            v-model="tag"
            :tags="tags"
            placeholder="Saisissez une valeur"
            @tags-changed="newTags => tags = newTags"
    />
</template>



<script>
    //import Component from 'path/to/component'
    import VueTagsInput from '@johmun/vue-tags-input';
    import FormElementMixin from '@/mixins/formElement.js'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            VueTagsInput
        },
        computed: {
            outputIsArray(){
                if(this.token.type.indexOf('array') != -1){
                    return true
                }
                return false
            }
        },
        created: function () {

        },
        data() {
            return {
                tag: '',
                tags: [],
            }
        },
        destroyed: function () {

        },
        methods: {
            changeHandler(){
                console.log(this.tags)
                if(this.outputIsArray){
                    this.updateValue(this.tags.map(item => {return item.text}))
                }
                else{
                    this.updateValue(this.tags.map(item => {return item.text}).join(','))
                }

            },
        },
        mixins:[
            FormElementMixin
        ],
        mounted: function () {
            if(this.outputIsArray){
                this.tags = this.value.map(item => {
                    return {
                        text: item
                    }
                })
            }
            else{
                if(this.value != "") {
                    this.tags = this.value.split(',')
                }
            }
        },
        name: '',
        props: {
            token: {
                type:Object,
                required: true
            }
        },
        updated: function () {

        },
        watch: {
            tags(){
                this.changeHandler()
            }
        }
    }
</script>

<style lang="scss">
    .vue-tags-input{
        width: 100%;

        .input{
            border: solid 2px $main-color!important;
        }

        .tag{
            background-color: $secondary-color!important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/plugins/formbuilder/elements/TagsManager.vue